import { call, put, takeLatest } from "redux-saga/effects";
import { setIsLoading } from "../../Containers/App/action";
import { getProfile, userFollowing } from "../../Domain/api";
import { setVisitedProfile } from "./action";
import { GET_VISITED_PROFILE, SET_FOLLOW } from "./constants";

export function* doGetVisitedProfile({ username, cbSuccess }) {
	try {
		yield put(setIsLoading(true));
		const { profile, followedBy } = yield call(getProfile, username);
		yield put(setVisitedProfile({ profile, followedBy }));
		yield put(setIsLoading(false));
		cbSuccess && cbSuccess({ profile, followedBy });
	} catch (error) {
		return;
	}
}

export function* doFollow({ mode, username }) {
	try {
		yield put(setIsLoading(true));
		yield call(userFollowing, { mode, username });
		yield put(setIsLoading(false));
	} catch (error) {
		return;
	}
}

export default function* homeSaga() {
	yield takeLatest(GET_VISITED_PROFILE, doGetVisitedProfile);
	yield takeLatest(SET_FOLLOW, doFollow);
}
